import { render, staticRenderFns } from "./FontIcon.vue?vue&type=template&id=1dae691a&lang=html&"
import script from "./FontIcon.vue?vue&type=script&lang=js&"
export * from "./FontIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports